import { InitFlow } from '@core/models/swagger/initFlow';
import { createAction, props } from '@ngrx/store';

export enum InitFlowActions {
  ResetInitFlow = '[Init Flow] Reset init flow',
  UpdateInitFlow = '[Init Flow] Update init flow',
}

export const ResetInitFlow = createAction(InitFlowActions.ResetInitFlow);

export const UpdateInitFlow = createAction(InitFlowActions.UpdateInitFlow, props<{ data: InitFlow }>());
